import { useSelector } from 'react-redux';
import { Button, Modal, Navigation } from '@vinted/web-ui';
import { Screen } from 'constants/tracking/screens';
import { PayInMethodSelection } from 'components/PayInMethodSelection';
import ContentLoader from 'components/ContentLoader';
import { PayInMethodCode } from 'constants/pay-in-method';
import * as extraServiceSelectors from 'state/extra-service/selectors';
import useTranslate from 'hooks/useTranslate';
import useTrackViewExtraServiceCheckout from '../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ExtraServicePayInMethodSelectionModal = _ref => {
  let {
    show,
    orderId,
    orderType,
    orderPayable,
    selectedCreditCardId,
    selectedPayInMethodId,
    onBack,
    onCancel,
    onConfirm,
    onAddCreditCard
  } = _ref;
  const translateModal = useTranslate('checkout.payment.select');
  const translatePayIntMethodSelection = useTranslate('payment_method_selection');
  const payInMethods = useSelector(extraServiceSelectors.getPayInMethods);
  const walletBalance = useSelector(extraServiceSelectors.getWalletBalance);
  const creditCards = useSelector(extraServiceSelectors.getPermanentCreditCards);
  const isWalletBalanceInsufficient = useSelector(state => extraServiceSelectors.getIsWalletBalanceInsufficient(state, orderPayable === null || orderPayable === void 0 ? void 0 : orderPayable.amount));
  useTrackViewExtraServiceCheckout({
    shouldTrack: show,
    orderId,
    orderType,
    screen: Screen.PaymentOptions
  });

  function handleCancel() {
    onCancel();
  }

  function handleBack() {
    onBack();
  }

  function handleAddCreditCard(method) {
    onAddCreditCard(method);
  }

  function handleMethodConfirmed(method, creditCardId) {
    if (method.code === PayInMethodCode.CreditCard && !creditCardId) {
      handleAddCreditCard(method);
      return;
    }

    onConfirm(method, creditCardId);
  }

  function renderNavigation() {
    return /*#__PURE__*/_jsx(Navigation, {
      body: translateModal('title'),
      right: /*#__PURE__*/_jsx(Button, {
        inline: true,
        deprecatedIconName: "x",
        styling: Button.Styling.Flat,
        testId: "extra-service-pay-in-method-selection-modal-close",
        onClick: handleCancel
      })
    });
  }

  function renderPayInMethodSelection() {
    if (!payInMethods.length) {
      return /*#__PURE__*/_jsx(ContentLoader, {
        styling: ContentLoader.Styling.Wide,
        testId: "extra-service-pay-in-methods-loader"
      });
    }

    const walletAvailability = {
      balance: walletBalance || null,
      isDisabled: isWalletBalanceInsufficient,
      reason: translatePayIntMethodSelection('validations.insufficient_wallet_funds')
    };
    return /*#__PURE__*/_jsx(PayInMethodSelection, {
      wrapInScrollableArea: true,
      creditCards: creditCards,
      wallet: walletAvailability,
      payInMethods: payInMethods,
      selectedCreditCardId: selectedCreditCardId,
      selectedPayInMethodId: selectedPayInMethodId,
      trackTargetDetails: {
        type: orderType,
        service_order_id: orderId
      },
      onBack: handleBack,
      onSubmit: handleMethodConfirmed,
      onAddNewCard: handleAddCreditCard
    });
  }

  return /*#__PURE__*/_jsx(Modal, {
    show: show,
    hasScrollableContent: true,
    testId: "extra-service-pay-in-method-selection-modal",
    children: /*#__PURE__*/_jsxs("div", {
      className: "u-fill-width",
      children: [renderNavigation(), renderPayInMethodSelection()]
    })
  });
};

export default ExtraServicePayInMethodSelectionModal;